import { useEffect } from 'react';
import { AdminHeaderButtonView } from '@vivli/shared/views';
import { useListingRequestContext } from '@vivli/features/listing-request/infrastructure/context';
import { ListingRequestStatusEnum } from '@vivli/features/listing-request/infrastructure/enum';
import { useFormState } from 'react-hook-form';
import { useModalApiContext } from '@vivli/core/infrastructure/context';
import { DTICommonConst } from '@vivli/shared/infrastructure/constants';

export const ListingRequestAdminHeaderButtonsComponent = () => {
    const { listingRequest, isLoading, isReadOnly, setIsReadOnly, handleFormSave, handleStatusUpdate } = useListingRequestContext();
    const { isValid } = useFormState();
    const modalService = useModalApiContext();
    const status = listingRequest?.status ? ListingRequestStatusEnum[listingRequest?.status] : null;
    const isDraft = status ? status === ListingRequestStatusEnum.Draft : false;
    const isSubmitted = status ? status === ListingRequestStatusEnum.Submitted : false;
    const isAccepted = status ? status === ListingRequestStatusEnum.StudyInCuration : false;
    const isWithdrawn = status ? status === ListingRequestStatusEnum.Withdrawn : false;
    const showWithdraw = !isWithdrawn && listingRequest?.id;
    const showResetToDraft = !isDraft && !isWithdrawn;
    const urlPathName = location.pathname.split('/')[3];
    const showEdit = !isWithdrawn && isReadOnly;

    const handleWithdraw = () => {
        //If the request has been approved (even if reset to draft) => modal will say that the withdraw is happening but will not delete the study
        //otherwise modal will warn that it is physically removing the study
        const modalMessage =
            listingRequest.approvedDate != null
                ? 'Continuing with the Withdraw will mark the submission withdrawn, but the study will remain posted - un-post the study separately if appropriate.'
                : 'Continuing with the Withdraw will mark the submission withdrawn, and will delete the temporary study that was created.';
        modalService.confirm(modalMessage, {
            title: 'Confirm Withdraw?',
            cancelText: 'Cancel',
            confirmText: 'OK',
            onConfirm: () => {
                handleStatusUpdate(listingRequest, ListingRequestStatusEnum.Withdrawn);
            }
        });
    };

    const handleStatusSave = () => {
        setIsReadOnly(urlPathName !== 'StatusUpdate');
        handleFormSave(false);
    };
    const handleSave = () => {
        handleStatusSave();
    };

    useEffect(() => {
        handleStatusSave();
    }, [urlPathName]);

    return (
        <>
            {showResetToDraft && (
                <AdminHeaderButtonView
                    dataId={DTICommonConst.ResetButton}
                    style={{ marginRight: 10 }}
                    title={'Reset to Draft'}
                    isLoading={isLoading}
                    isDisabled={isLoading || !isReadOnly}
                    onClick={() => handleStatusUpdate(listingRequest, ListingRequestStatusEnum.Draft)}
                />
            )}
            {showWithdraw && (
                <AdminHeaderButtonView
                    style={{ marginRight: 10 }}
                    title={'Withdraw'}
                    isLoading={isLoading}
                    isDisabled={isLoading}
                    onClick={handleWithdraw}
                />
            )}
            {showEdit && (
                <AdminHeaderButtonView
                    style={{ marginRight: 10 }}
                    title={'Edit'}
                    isLoading={isLoading}
                    isDisabled={isLoading}
                    onClick={() => setIsReadOnly(false)}
                />
            )}
            {!isReadOnly && (
                <AdminHeaderButtonView
                    style={{ marginRight: 10 }}
                    title={'Save'}
                    isLoading={isLoading}
                    isDisabled={isLoading}
                    onClick={handleSave}
                />
            )}
            {isDraft && (
                <AdminHeaderButtonView
                    style={{ marginRight: 10 }}
                    title={'Submit'}
                    isLoading={isLoading}
                    isDisabled={isLoading || !isValid}
                    onClick={() => handleFormSave(true, ListingRequestStatusEnum.Submitted)}
                />
            )}
            {isSubmitted && (
                <AdminHeaderButtonView
                    style={{ marginRight: 10 }}
                    title={'Accept'}
                    isLoading={isLoading}
                    isDisabled={isLoading || !isReadOnly || !isValid}
                    onClick={() => handleStatusUpdate(listingRequest, ListingRequestStatusEnum.StudyInCuration)}
                />
            )}
            {isAccepted && (
                <AdminHeaderButtonView
                    style={{ marginRight: 10 }}
                    title={'Approve/Post'}
                    isLoading={isLoading}
                    isDisabled={isLoading || !isReadOnly || !isValid}
                    onClick={() => handleStatusUpdate(listingRequest, ListingRequestStatusEnum.Approved)}
                />
            )}
        </>
    );
};
